module.exports = __webpack_public_path__ + "static/media/rebirth_cover.c6cecf91.jpg";